import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  token: string = '';
  type: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;

  loading: boolean = false;
  success: boolean = false;
  successMessage: string = '';
  errorMessage: string = '';
  invalidLink: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.token = this.route.snapshot.queryParams['token'] || '';
    this.type = this.route.snapshot.queryParams['type'] || '';

    if (!this.token || !this.type) {
      this.invalidLink = true;
    }
  }

  get passwordsMatch(): boolean {
    return this.newPassword === this.confirmPassword;
  }

  get formValid(): boolean {
    return this.newPassword.length >= 4 && this.passwordsMatch && !this.loading;
  }

  submitReset() {
    this.errorMessage = '';
    this.loading = true;

    this.http.post<any>('/api/auth/reset-password', {
      token: this.token,
      type: this.type,
      newPassword: this.newPassword
    }).subscribe(
      (res) => {
        this.loading = false;
        this.success = true;
        this.successMessage = res.message;
      },
      (err) => {
        this.loading = false;
        this.errorMessage = (err.error && err.error.message) ? err.error.message : 'Une erreur est survenue.';
      }
    );
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/reset-password/reset-password.component.ts